<template>
 <a-drawer class="filter-condition" title="设置筛选条件" placement="bottom" :visible="visible" @close="visible=false" height="50%">
   <div class="condition-accourd">
      <span>符合以下</span>
      <a-select v-model="relation" @change="relationChange">
        <a-select-option value="AND">所有</a-select-option>
        <a-select-option value="OR">任一</a-select-option> 
      </a-select>
      <span>条件</span>
    </div>
    <div class="condition-box">
      <div v-for="(v,i) in list" :key="i">
        <filterConditionItem :dataSetValue="dataSetValue" :fields="fields" :tableId="tableId" :list="list" :index="i" @delete="() => deleteClick(i)"></filterConditionItem>
      </div>
    </div>
    <a-button type="link" @click="addClick"><icon-font type="icon-plus-square"></icon-font><span>添加筛选条件</span></a-button>
    <div class="bottom-btn">
      <a-button @click="visible=false">取消</a-button>
      <a-button type="primary" @click="save">保存</a-button>
    </div>
 </a-drawer>
</template>

<script>
import filterConditionItem from "./filterConditionItem.vue"

export default {
  name: "FilterCondition",
  props: ['dataSetValue', 'fields', 'tableId'],
  data() {
    return {
      visible: false,
      list: [],
      relation: "AND"
    };
  },
  components: {
    filterConditionItem
  },
  mounted() {
  },
  methods: {
    init(list) {
      console.log(list)
      this.visible = true
      if(list&&list.length) {
        this.list = list
        this.relation = list[0].relation
      } else {
        this.list = list.length?list:[{
          name: undefined,
          op: undefined,
          value: undefined,
          relation: 'AND',
          dataType: 'NUMBER',
          id: undefined
        }]
        this.relation = 'AND'
      }
    },
    save() {
      for (let i = 0; i < this.list.length; i++) {
        const obj = this.list[i];
        if(!obj.name) {
          this.$message.error('请选择筛选维度指标！')
          return
        }
        if(!obj.op) {
          this.$message.error('请选择运算符！')
          return
        }
        if((!obj.value&&obj.value !== 0) || (Array.isArray(obj.value)&&!obj.value.length)) {
          this.$message.error('请输入条件')
          return
        }
      }
      this.$emit("save", this.list)
      this.visible = false
    },
    addClick() {
      this.list.push({
        name: undefined,
        op: undefined,
        value: undefined,
        relation: this.relation,
        dataType: 'NUMBER',
        id: undefined
      })
    },
    deleteClick(i) {
      this.list.splice(i, 1)
    },
    relationChange(val) {
      this.list.forEach(v => {
        v.relation = val
      })
    }
  }
};
</script>
<style lang="less" scoped>
  .condition-accourd {
    margin-bottom: 12px;
    .ant-select {
      width: 76px;
      margin: 0px 8px;
      background: #F3F6FE;
      border-radius: 6px;
      color: #2D3446;
      font-size: 14px;
      font-weight: 400;
      /deep/ .ant-select-selection {
        border: 0;
        background-color: transparent;
        box-shadow: none;
      }
    }
  }
  .condition-box {
    max-height: calc(100% - 72px);
    overflow: auto;
  }
</style>
<style lang="less">
.filter-condition{
  .ant-drawer-body {
    height: calc(100% - 55px);
    box-sizing: border-box;
    position: relative;
    .bottom-btn {
      position: absolute;
      bottom: 10px;
      right: 16px;
      & > * {
        margin-left: 8px;
      }
    }
  }
}
</style>